import { jsx as b, jsxs as V } from "react/jsx-runtime";
import { forwardRef as H, useState as D, useEffect as te, useMemo as U, useCallback as K, memo as ue, useRef as Ce, useImperativeHandle as Xe } from "react";
import { c as M } from "./tw-cn-mXgPecoF.mjs";
import { c as We } from "./index-BpNK5r1N.mjs";
import { u as Je } from "./use-focus-BGKOEgog.mjs";
import { a as De, b as z, r as w, i as F, f as Ye, S as pe } from "./isObjectLike-BurtZzWI.mjs";
var q = Array.isArray, Ze = "[object AsyncFunction]", Qe = "[object Function]", ke = "[object GeneratorFunction]", et = "[object Proxy]";
function Re(e) {
  if (!De(e))
    return !1;
  var t = z(e);
  return t == Qe || t == ke || t == Ze || t == et;
}
var Q = w["__core-js_shared__"], ge = function() {
  var e = /[^.]+$/.exec(Q && Q.keys && Q.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function tt(e) {
  return !!ge && ge in e;
}
var rt = Function.prototype, nt = rt.toString;
function P(e) {
  if (e != null) {
    try {
      return nt.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var at = /[\\^$.*+?()[\]{}|]/g, it = /^\[object .+?Constructor\]$/, st = Function.prototype, ot = Object.prototype, ut = st.toString, lt = ot.hasOwnProperty, ft = RegExp(
  "^" + ut.call(lt).replace(at, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ct(e) {
  if (!De(e) || tt(e))
    return !1;
  var t = Re(e) ? ft : it;
  return t.test(P(e));
}
function dt(e, t) {
  return e == null ? void 0 : e[t];
}
function N(e, t) {
  var r = dt(e, t);
  return ct(r) ? r : void 0;
}
var re = N(w, "WeakMap"), pt = 9007199254740991, gt = /^(?:0|[1-9]\d*)$/;
function _t(e, t) {
  var r = typeof e;
  return t = t ?? pt, !!t && (r == "number" || r != "symbol" && gt.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Me(e, t) {
  return e === t || e !== e && t !== t;
}
var ht = 9007199254740991;
function Fe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= ht;
}
function yt(e) {
  return e != null && Fe(e.length) && !Re(e);
}
var vt = Object.prototype;
function bt(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || vt;
  return e === r;
}
function mt(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var Tt = "[object Arguments]";
function _e(e) {
  return F(e) && z(e) == Tt;
}
var Le = Object.prototype, At = Le.hasOwnProperty, xt = Le.propertyIsEnumerable, wt = _e(/* @__PURE__ */ function() {
  return arguments;
}()) ? _e : function(e) {
  return F(e) && At.call(e, "callee") && !xt.call(e, "callee");
};
function Ot() {
  return !1;
}
var Ge = typeof exports == "object" && exports && !exports.nodeType && exports, he = Ge && typeof module == "object" && module && !module.nodeType && module, St = he && he.exports === Ge, ye = St ? w.Buffer : void 0, $t = ye ? ye.isBuffer : void 0, ne = $t || Ot, Pt = "[object Arguments]", Et = "[object Array]", jt = "[object Boolean]", Nt = "[object Date]", It = "[object Error]", Ct = "[object Function]", Dt = "[object Map]", Rt = "[object Number]", Mt = "[object Object]", Ft = "[object RegExp]", Lt = "[object Set]", Gt = "[object String]", Ht = "[object WeakMap]", zt = "[object ArrayBuffer]", Bt = "[object DataView]", Ut = "[object Float32Array]", Vt = "[object Float64Array]", Kt = "[object Int8Array]", qt = "[object Int16Array]", Xt = "[object Int32Array]", Wt = "[object Uint8Array]", Jt = "[object Uint8ClampedArray]", Yt = "[object Uint16Array]", Zt = "[object Uint32Array]", f = {};
f[Ut] = f[Vt] = f[Kt] = f[qt] = f[Xt] = f[Wt] = f[Jt] = f[Yt] = f[Zt] = !0;
f[Pt] = f[Et] = f[zt] = f[jt] = f[Bt] = f[Nt] = f[It] = f[Ct] = f[Dt] = f[Rt] = f[Mt] = f[Ft] = f[Lt] = f[Gt] = f[Ht] = !1;
function Qt(e) {
  return F(e) && Fe(e.length) && !!f[z(e)];
}
function kt(e) {
  return function(t) {
    return e(t);
  };
}
var He = typeof exports == "object" && exports && !exports.nodeType && exports, R = He && typeof module == "object" && module && !module.nodeType && module, er = R && R.exports === He, k = er && Ye.process, ve = function() {
  try {
    var e = R && R.require && R.require("util").types;
    return e || k && k.binding && k.binding("util");
  } catch {
  }
}(), be = ve && ve.isTypedArray, ze = be ? kt(be) : Qt, tr = Object.prototype, rr = tr.hasOwnProperty;
function nr(e, t) {
  var r = q(e), n = !r && wt(e), i = !r && !n && ne(e), a = !r && !n && !i && ze(e), s = r || n || i || a, o = s ? mt(e.length, String) : [], u = o.length;
  for (var l in e)
    rr.call(e, l) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    _t(l, u))) && o.push(l);
  return o;
}
function ar(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var ir = ar(Object.keys, Object), sr = Object.prototype, or = sr.hasOwnProperty;
function ur(e) {
  if (!bt(e))
    return ir(e);
  var t = [];
  for (var r in Object(e))
    or.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function lr(e) {
  return yt(e) ? nr(e) : ur(e);
}
var L = N(Object, "create");
function fr() {
  this.__data__ = L ? L(null) : {}, this.size = 0;
}
function cr(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var dr = "__lodash_hash_undefined__", pr = Object.prototype, gr = pr.hasOwnProperty;
function _r(e) {
  var t = this.__data__;
  if (L) {
    var r = t[e];
    return r === dr ? void 0 : r;
  }
  return gr.call(t, e) ? t[e] : void 0;
}
var hr = Object.prototype, yr = hr.hasOwnProperty;
function vr(e) {
  var t = this.__data__;
  return L ? t[e] !== void 0 : yr.call(t, e);
}
var br = "__lodash_hash_undefined__";
function mr(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = L && t === void 0 ? br : t, this;
}
function $(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
$.prototype.clear = fr;
$.prototype.delete = cr;
$.prototype.get = _r;
$.prototype.has = vr;
$.prototype.set = mr;
function Tr() {
  this.__data__ = [], this.size = 0;
}
function W(e, t) {
  for (var r = e.length; r--; )
    if (Me(e[r][0], t))
      return r;
  return -1;
}
var Ar = Array.prototype, xr = Ar.splice;
function wr(e) {
  var t = this.__data__, r = W(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : xr.call(t, r, 1), --this.size, !0;
}
function Or(e) {
  var t = this.__data__, r = W(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function Sr(e) {
  return W(this.__data__, e) > -1;
}
function $r(e, t) {
  var r = this.__data__, n = W(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function T(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
T.prototype.clear = Tr;
T.prototype.delete = wr;
T.prototype.get = Or;
T.prototype.has = Sr;
T.prototype.set = $r;
var G = N(w, "Map");
function Pr() {
  this.size = 0, this.__data__ = {
    hash: new $(),
    map: new (G || T)(),
    string: new $()
  };
}
function Er(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function J(e, t) {
  var r = e.__data__;
  return Er(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function jr(e) {
  var t = J(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Nr(e) {
  return J(this, e).get(e);
}
function Ir(e) {
  return J(this, e).has(e);
}
function Cr(e, t) {
  var r = J(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function E(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
E.prototype.clear = Pr;
E.prototype.delete = jr;
E.prototype.get = Nr;
E.prototype.has = Ir;
E.prototype.set = Cr;
function Dr(e, t) {
  for (var r = -1, n = t.length, i = e.length; ++r < n; )
    e[i + r] = t[r];
  return e;
}
function Rr() {
  this.__data__ = new T(), this.size = 0;
}
function Mr(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function Fr(e) {
  return this.__data__.get(e);
}
function Lr(e) {
  return this.__data__.has(e);
}
var Gr = 200;
function Hr(e, t) {
  var r = this.__data__;
  if (r instanceof T) {
    var n = r.__data__;
    if (!G || n.length < Gr - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new E(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function x(e) {
  var t = this.__data__ = new T(e);
  this.size = t.size;
}
x.prototype.clear = Rr;
x.prototype.delete = Mr;
x.prototype.get = Fr;
x.prototype.has = Lr;
x.prototype.set = Hr;
function zr(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = 0, a = []; ++r < n; ) {
    var s = e[r];
    t(s, r, e) && (a[i++] = s);
  }
  return a;
}
function Br() {
  return [];
}
var Ur = Object.prototype, Vr = Ur.propertyIsEnumerable, me = Object.getOwnPropertySymbols, Kr = me ? function(e) {
  return e == null ? [] : (e = Object(e), zr(me(e), function(t) {
    return Vr.call(e, t);
  }));
} : Br;
function qr(e, t, r) {
  var n = t(e);
  return q(e) ? n : Dr(n, r(e));
}
function Te(e) {
  return qr(e, lr, Kr);
}
var ae = N(w, "DataView"), ie = N(w, "Promise"), se = N(w, "Set"), Ae = "[object Map]", Xr = "[object Object]", xe = "[object Promise]", we = "[object Set]", Oe = "[object WeakMap]", Se = "[object DataView]", Wr = P(ae), Jr = P(G), Yr = P(ie), Zr = P(se), Qr = P(re), A = z;
(ae && A(new ae(new ArrayBuffer(1))) != Se || G && A(new G()) != Ae || ie && A(ie.resolve()) != xe || se && A(new se()) != we || re && A(new re()) != Oe) && (A = function(e) {
  var t = z(e), r = t == Xr ? e.constructor : void 0, n = r ? P(r) : "";
  if (n)
    switch (n) {
      case Wr:
        return Se;
      case Jr:
        return Ae;
      case Yr:
        return xe;
      case Zr:
        return we;
      case Qr:
        return Oe;
    }
  return t;
});
var $e = w.Uint8Array, kr = "__lodash_hash_undefined__";
function en(e) {
  return this.__data__.set(e, kr), this;
}
function tn(e) {
  return this.__data__.has(e);
}
function X(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new E(); ++t < r; )
    this.add(e[t]);
}
X.prototype.add = X.prototype.push = en;
X.prototype.has = tn;
function rn(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function nn(e, t) {
  return e.has(t);
}
var an = 1, sn = 2;
function Be(e, t, r, n, i, a) {
  var s = r & an, o = e.length, u = t.length;
  if (o != u && !(s && u > o))
    return !1;
  var l = a.get(e), y = a.get(t);
  if (l && y)
    return l == t && y == e;
  var d = -1, c = !0, v = r & sn ? new X() : void 0;
  for (a.set(e, t), a.set(t, e); ++d < o; ) {
    var h = e[d], g = t[d];
    if (n)
      var p = s ? n(g, h, d, t, e, a) : n(h, g, d, e, t, a);
    if (p !== void 0) {
      if (p)
        continue;
      c = !1;
      break;
    }
    if (v) {
      if (!rn(t, function(_, m) {
        if (!nn(v, m) && (h === _ || i(h, _, r, n, a)))
          return v.push(m);
      })) {
        c = !1;
        break;
      }
    } else if (!(h === g || i(h, g, r, n, a))) {
      c = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), c;
}
function on(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, i) {
    r[++t] = [i, n];
  }), r;
}
function un(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var ln = 1, fn = 2, cn = "[object Boolean]", dn = "[object Date]", pn = "[object Error]", gn = "[object Map]", _n = "[object Number]", hn = "[object RegExp]", yn = "[object Set]", vn = "[object String]", bn = "[object Symbol]", mn = "[object ArrayBuffer]", Tn = "[object DataView]", Pe = pe ? pe.prototype : void 0, ee = Pe ? Pe.valueOf : void 0;
function An(e, t, r, n, i, a, s) {
  switch (r) {
    case Tn:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case mn:
      return !(e.byteLength != t.byteLength || !a(new $e(e), new $e(t)));
    case cn:
    case dn:
    case _n:
      return Me(+e, +t);
    case pn:
      return e.name == t.name && e.message == t.message;
    case hn:
    case vn:
      return e == t + "";
    case gn:
      var o = on;
    case yn:
      var u = n & ln;
      if (o || (o = un), e.size != t.size && !u)
        return !1;
      var l = s.get(e);
      if (l)
        return l == t;
      n |= fn, s.set(e, t);
      var y = Be(o(e), o(t), n, i, a, s);
      return s.delete(e), y;
    case bn:
      if (ee)
        return ee.call(e) == ee.call(t);
  }
  return !1;
}
var xn = 1, wn = Object.prototype, On = wn.hasOwnProperty;
function Sn(e, t, r, n, i, a) {
  var s = r & xn, o = Te(e), u = o.length, l = Te(t), y = l.length;
  if (u != y && !s)
    return !1;
  for (var d = u; d--; ) {
    var c = o[d];
    if (!(s ? c in t : On.call(t, c)))
      return !1;
  }
  var v = a.get(e), h = a.get(t);
  if (v && h)
    return v == t && h == e;
  var g = !0;
  a.set(e, t), a.set(t, e);
  for (var p = s; ++d < u; ) {
    c = o[d];
    var _ = e[c], m = t[c];
    if (n)
      var I = s ? n(m, _, c, t, e, a) : n(_, m, c, e, t, a);
    if (!(I === void 0 ? _ === m || i(_, m, r, n, a) : I)) {
      g = !1;
      break;
    }
    p || (p = c == "constructor");
  }
  if (g && !p) {
    var j = e.constructor, O = t.constructor;
    j != O && "constructor" in e && "constructor" in t && !(typeof j == "function" && j instanceof j && typeof O == "function" && O instanceof O) && (g = !1);
  }
  return a.delete(e), a.delete(t), g;
}
var $n = 1, Ee = "[object Arguments]", je = "[object Array]", B = "[object Object]", Pn = Object.prototype, Ne = Pn.hasOwnProperty;
function En(e, t, r, n, i, a) {
  var s = q(e), o = q(t), u = s ? je : A(e), l = o ? je : A(t);
  u = u == Ee ? B : u, l = l == Ee ? B : l;
  var y = u == B, d = l == B, c = u == l;
  if (c && ne(e)) {
    if (!ne(t))
      return !1;
    s = !0, y = !1;
  }
  if (c && !y)
    return a || (a = new x()), s || ze(e) ? Be(e, t, r, n, i, a) : An(e, t, u, r, n, i, a);
  if (!(r & $n)) {
    var v = y && Ne.call(e, "__wrapped__"), h = d && Ne.call(t, "__wrapped__");
    if (v || h) {
      var g = v ? e.value() : e, p = h ? t.value() : t;
      return a || (a = new x()), i(g, p, r, n, a);
    }
  }
  return c ? (a || (a = new x()), Sn(e, t, r, n, i, a)) : !1;
}
function Ue(e, t, r, n, i) {
  return e === t ? !0 : e == null || t == null || !F(e) && !F(t) ? e !== e && t !== t : En(e, t, r, n, Ue, i);
}
function jn(e, t) {
  return Ue(e, t);
}
const Nn = We(
  [
    "max-h-[340px] block min-h-72 w-full resize-none overflow-y-auto placeholder:text-text-neutral-medium text-text-neutral-main disabled:text-interaction-neutral-disable-main disabled:placeholder:text-interaction-neutral-disable-main disabled:bg-fill-neutral-weak typography-body-14-regular-multiline border border-solid relative border-line-neutral-weak3 rounded-8 px-16 py-12"
  ],
  {
    variants: {
      isFocused: {
        true: "border-2 px-15 py-11",
        false: ""
      },
      disabled: {
        true: "bg-fill-neutral-weak",
        false: "bg-static-white"
      }
    },
    defaultVariants: {
      isFocused: !1,
      disabled: !1
    }
  }
), oe = 340, In = 21, Cn = 24, Dn = (e) => {
  const t = Math.min(e, oe) - Cn;
  return Math.floor(t / In);
}, le = H(
  ({ maxHeight: e = oe, disabled: t, hasError: r, defaultValue: n, maxLength: i, id: a, value: s, onChange: o, ...u }, l) => {
    e > oe && process.env.NODE_ENV === "development" && console.warn("maxHeight: maxHeight must be less than or equal to 340.");
    const [y, d] = D(null);
    te(() => {
      import("./react-textarea-autosize.browser.esm-B2yGxKRM.mjs").then((S) => {
        d(() => S.default);
      });
    }, []);
    const [c, v] = D(null), h = U(() => ({ current: c }), [c]), { isFocused: g } = Je(h), p = s !== void 0, [_, m] = D(n || ""), I = p ? s : _, j = U(() => Math.max(1, Dn(e)), [e]), O = U(() => t ? "border-line-neutral-weak3" : r ? "border-line-danger-main caret-text-danger-main" : g ? "border-line-neutral-main" : "border-line-neutral-weak3", [t, r, g]), fe = Nn({ isFocused: g, disabled: t }), ce = K((S) => {
      v(S);
    }, []), de = K(
      (S) => {
        let { value: C } = S.target;
        i && C.length > i && (C = C.slice(0, i), S.target.value = C), p || m(C), o == null || o(S);
      },
      [p, i, o]
    );
    return te(() => {
      p && m(I);
    }, [p, I]), y ? /* @__PURE__ */ b(
      y,
      {
        className: M(fe, O),
        defaultValue: p ? void 0 : n,
        disabled: t,
        id: a,
        maxLength: i,
        maxRows: j,
        name: "textField",
        onChange: de,
        ref: ce,
        value: p ? s : _,
        ...u
      }
    ) : /* @__PURE__ */ b(
      "textarea",
      {
        className: M(fe, O),
        defaultValue: p ? void 0 : n,
        disabled: t,
        id: a,
        maxLength: i,
        name: "textField",
        onChange: de,
        ref: ce,
        value: p ? s : _,
        ...u
      }
    );
  }
);
le.displayName = "NDS.BaseTextArea";
const Y = H(({ children: e, ...t }, r) => /* @__PURE__ */ b("label", { ref: r, ...t, className: "flex-start flex w-full", children: typeof e == "string" ? /* @__PURE__ */ b("span", { className: "line-clamp-1 text-text-neutral-main typography-body-13-regular", children: e }) : e }));
Y.displayName = "NDS.Label";
ue(Y, jn);
const Z = ({
  leftContent: e,
  leftContentClassName: t,
  currentLength: r,
  maxLength: n,
  hasError: i,
  disabled: a
}) => {
  const s = U(() => a ? "text-interaction-neutral-disable-main" : i ? "text-text-danger-main" : "text-text-neutral-main", [a, i]);
  return /* @__PURE__ */ V("div", { className: "flex w-full justify-between px-16 text-left", children: [
    e ? /* @__PURE__ */ b("div", { className: M("mr-8 line-clamp-2 typography-body-12-regular", s, t), children: e }) : null,
    !a && n !== void 0 && r !== void 0 ? /* @__PURE__ */ V("div", { className: "ml-auto typography-body-12-regular", children: [
      /* @__PURE__ */ b("span", { className: "font-bold", children: r.toLocaleString() }),
      "/",
      n.toLocaleString()
    ] }) : null
  ] });
};
Z.displayName = "NDS.SupportText";
ue(Z);
const Ve = H(
  ({ label: e, supportLeftContent: t, onChange: r, className: n, textAreaRef: i, ...a }, s) => {
    const o = Ce(null);
    Xe(s, () => o.current);
    const u = K(
      (l) => {
        r == null || r(l);
      },
      [r]
    );
    return /* @__PURE__ */ V("div", { className: M("flex w-full flex-col gap-8", n), ref: o, children: [
      e ? /* @__PURE__ */ b(Y, { htmlFor: a.id, children: e }) : null,
      /* @__PURE__ */ b(le, { onChange: u, ref: i, ...a }),
      t ? /* @__PURE__ */ b(Z, { disabled: a.disabled, hasError: a.hasError, leftContent: t }) : null
    ] });
  }
);
Ve.displayName = "NDS.DefaultTextArea";
const Ie = (e) => typeof e == "string" ? e : typeof e == "number" ? e.toString() : Array.isArray(e) ? e.join(",") : "", Ke = H(
  ({ label: e, supportLeftContent: t, maxLength: r, value: n, defaultValue: i, onChange: a, className: s, textAreaRef: o, ...u }, l) => {
    const y = Ce(null), d = n !== void 0, [c, v] = D(Ie(n ?? i ?? "")), [h, g] = D(c.length), p = K(
      (_) => {
        const { value: m } = _.target;
        d || v(m), a == null || a(_), g(m.length);
      },
      [a, d]
    );
    return te(() => {
      if (d) {
        const _ = Ie(n);
        v(_), g(_.length);
      }
    }, [d, n]), /* @__PURE__ */ V("div", { className: M("flex w-full flex-col gap-8", s), ref: y, children: [
      e ? /* @__PURE__ */ b(Y, { htmlFor: u.id, children: e }) : null,
      /* @__PURE__ */ b(
        le,
        {
          defaultValue: d ? void 0 : i,
          maxLength: r,
          onChange: p,
          ref: o,
          value: d ? c : void 0,
          ...u
        }
      ),
      /* @__PURE__ */ b(
        Z,
        {
          currentLength: h,
          disabled: u.disabled,
          hasError: u.hasError,
          leftContent: t,
          maxLength: r
        }
      )
    ] });
  }
);
Ke.displayName = "NDS.NeedsCharCountTextArea";
const qe = H(({ maxLength: e, ...t }, r) => e === void 0 ? /* @__PURE__ */ b(Ve, { ref: r, ...t }) : /* @__PURE__ */ b(Ke, { maxLength: e, ref: r, ...t }));
qe.displayName = "NDS.TextArea";
ue(qe);
export {
  qe as T
};
